
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/calcPage.js"
  import data from "/opt/build/repo/.cache/json/layout-calc-page.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/calcPage.js